/* Shared enhancements that do not alter Shopify's product forms or app ownership. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function enhanceTables(root) {
    root.querySelectorAll('.rte table, .content-block table').forEach(function (table) {
      if (table.parentElement.classList.contains('turnpaugh-table-scroll')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'turnpaugh-table-scroll';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', (window.theme && theme.strings && theme.strings.scrollableTable) || 'Scrollable table');
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  function enhanceMessages(root) {
    root.querySelectorAll('.form-success').forEach(function (node) {
      node.setAttribute('role', 'status');
    });
    root.querySelectorAll('.errors, .form-error, .errors ul').forEach(function (node) {
      if (!node.closest('[role="alert"]')) node.setAttribute('role', 'alert');
    });
  }

  function enhanceVideo(root) {
    root.querySelectorAll('video[autoplay]').forEach(function (video) {
      video.controls = true;
      if (reduceMotion && reduceMotion.matches) {
        video.autoplay = false;
        video.pause();
      }
    });
  }

  function enhanceCarousel(carousel) {
    if (carousel.dataset.turnpaughAutoplayControl === 'true') return;
    if (!window.jQuery || !window.jQuery.fn.slick) return;
    var slider = window.jQuery(carousel);
    var slick = slider.slick('getSlick');
    if (!slick || !slick.options || !slick.options.autoplay) return;
    var button = document.createElement('button');
    var paused = !!(reduceMotion && reduceMotion.matches);
    button.type = 'button';
    button.className = 'turnpaugh-carousel-pause';
    button.textContent = paused ? theme.strings.playSlideshow : theme.strings.pauseSlideshow;
    button.setAttribute('aria-pressed', String(paused));
    button.addEventListener('click', function () {
      paused = !paused;
      slider.slick(paused ? 'slickPause' : 'slickPlay');
      button.textContent = paused ? theme.strings.playSlideshow : theme.strings.pauseSlideshow;
      button.setAttribute('aria-pressed', String(paused));
    });
    carousel.insertAdjacentElement('afterend', button);
    carousel.dataset.turnpaughAutoplayControl = 'true';
    if (paused) slider.slick('slickPause');
  }

  function enhance(root) {
    enhanceTables(root);
    enhanceMessages(root);
    enhanceVideo(root);
    root.querySelectorAll('.slick-initialized').forEach(enhanceCarousel);
  }

  document.addEventListener('DOMContentLoaded', function () {
    enhance(document);
    if (window.jQuery) {
      window.jQuery(document).on('init reInit', '.slideshow, .slick-slider, [data-section-type="slideshow"]', function (event) {
        var carousel = event.currentTarget;
        window.requestAnimationFrame(function () { enhanceCarousel(carousel); });
      });
    }
    document.addEventListener('shopify:section:load', function (event) { enhance(event.target); });
  });
})();
